import {
  createContext,
  Dispatch,
  ReactNode,
  SetStateAction,
  useCallback,
  useContext,
  useState,
} from 'react';

export type Page = 'home' | 'catalog' | 'product';

export interface DemoContextValue {
  page: Page;
  setPage: Dispatch<SetStateAction<Page>>;
  productId: string;
  handleProduct: (productId: string) => void;
  navigationHistory: string[];
  setNavigationHistory: Dispatch<SetStateAction<string[]>>;
}

export const DemoContext = createContext({} as DemoContextValue);

interface DemoProviderProps {
  children: ReactNode;
}

export function DemoProvider({ children }: DemoProviderProps) {
  const [page, setPage] = useState<Page>('home');
  const [productId, setProductId] = useState('');
  const [navigationHistory, setNavigationHistory] = useState<string[]>([]);

  const handleProduct = useCallback((productId: string) => {
    setProductId(productId);
    setPage('product');
  }, []);

  return (
    <DemoContext.Provider
      value={{
        page,
        setPage,
        productId,
        handleProduct,
        navigationHistory,
        setNavigationHistory,
      }}
    >
      {children}
    </DemoContext.Provider>
  );
}

export function useDemo() {
  return useContext(DemoContext);
}
